import { Box, Card, Flex, GridAlpha, Heading } from '@applyboard/crystal-ui';
import { CreditCardFillIcon, PersonIcon, PersonRemoveFillIcon } from '@applyboard/ui-icons';
import { VasSpinner } from '../../components/Spinner';

const AssignedIcon = <PersonIcon variant="fill" size="lg" />;
const UnassignedIcon = <PersonRemoveFillIcon size="lg" />;
const VoucherIcon = <CreditCardFillIcon size="lg" />;

interface VoucherStatisticsCardProps {
  name: string;
  value: string;
  icon: JSX.Element;
}

function VoucherStatisticsCard({ name, value, icon }: VoucherStatisticsCardProps) {
  return (
    <>
      <Card>
        <Box px={4}>
          <Flex direction="row" justify="between" align="center" gap={8}>
            <Flex direction="column" align="start">
              <Heading level={3} intent="secondary" variant="bodyS">
                {name}
              </Heading>
              <Heading level={3} intent="secondary" variant="titleL">
                {value}
              </Heading>
            </Flex>
            <Box pr={2}>
              <Card>{icon}</Card>
            </Box>
          </Flex>
        </Box>
      </Card>
    </>
  );
}

interface VoucherStatisticsProps {
  statistics?: {
    total_vouchers: number;
    total_assigned: number;
    total_unassigned: number;
  };
  loading: boolean;
}

function VoucherStatistics({ statistics, loading }: VoucherStatisticsProps) {
  return (
    <>
      <Box pt={2}>
        {loading && (
          <Flex width="fill" justify="center">
            <VasSpinner />
          </Flex>
        )}
        {!loading && (
          <>
            <GridAlpha columns="repeat(9, 1fr)" rowGap={{ xs: 2, md: 8 }} columnGap={8}>
              <GridAlpha.Item columnStart={{ xs: 1, md: 1 }} columnEnd={{ xs: 10, md: 4 }}>
                <VoucherStatisticsCard
                  name="Total Vouchers"
                  value={statistics?.total_vouchers.toString() ?? 'Not Available'}
                  icon={VoucherIcon}
                />
              </GridAlpha.Item>

              <GridAlpha.Item columnStart={{ xs: 1, md: 4 }} columnEnd={{ xs: 10, md: 7 }}>
                <VoucherStatisticsCard
                  name="Assigned"
                  value={statistics?.total_assigned.toString() ?? 'Not Available'}
                  icon={AssignedIcon}
                />
              </GridAlpha.Item>

              <GridAlpha.Item columnStart={{ xs: 1, md: 7 }} columnEnd={10}>
                <VoucherStatisticsCard
                  name="Unassigned"
                  value={statistics?.total_unassigned.toString() ?? 'Not Available'}
                  icon={UnassignedIcon}
                />
              </GridAlpha.Item>
            </GridAlpha>
          </>
        )}
      </Box>
    </>
  );
}

export default VoucherStatistics;
